import { UnidadState } from "./unidad.reduccer";
import * as AppState from "../../_state/app.state";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AGRUPADORES } from "../models/mock/agrupador-mock";

export interface State extends AppState.State {
  unidad: UnidadState,
}

const unidadSelector = createFeatureSelector<UnidadState>('unidad');

export const getError = createSelector(
  unidadSelector,
  state => state.error
);

export const getLoading = createSelector(
  unidadSelector,
  state => state.loading
);

export const getUpdating = createSelector(
  unidadSelector,
  state => state.updating
);

export const getSelectedUnidadMetaId = createSelector(
  unidadSelector,
  state => state.selectedUnidadMetaId
);

export const getSelectedUnidadMeta = createSelector(
  unidadSelector,
  getSelectedUnidadMetaId,
  (state, idUnidadMeta) => state.unidadMetas.find(m => m.id === idUnidadMeta)
);

export const getUnidad = createSelector(
  unidadSelector,
  state => state.unidad
);

export const getUnidadMetas = createSelector(
  unidadSelector,
  state => state.unidadMetas
);

export const getAgrupadores = createSelector(
  unidadSelector,
  state => AGRUPADORES
);

export const getEscalas = createSelector(
  unidadSelector,
  state => state.escalas
);

export const getViewModel = createSelector(
  getLoading,
  getUpdating,
  getError,
  getEscalas,
  getUnidad,
  getUnidadMetas,
  getAgrupadores,
  (
    loading, updating, error, escalas, unidad, unidadMetas, agrupadores,
  ) => ({ loading, updating, error, escalas, unidad, unidadMetas, agrupadores, })
);

export const getMetaViewModel = createSelector(
  getUpdating,
  getError,
  getSelectedUnidadMeta,
  (loading, error, unidadMeta) => ({ loading, error, unidadMeta })
);
